import { IChangeRequest } from '@/data/models/changeRequest';
import { ICurrentChanges } from '@/types/product-current-changes-types';
import { merchCurrentChanges } from '@/utils/changeRequest/merchCurrentChanges';
import { productCurrentChanges } from '@/utils/changeRequest/productCurrentChanges';

/**
 * Builds the current-change summary for the active Change Request.
 *
 * Merchandise products have a different current-change builder because their
 * metadata shape differs from regular albums.
 */
export const buildCurrentChanges = (
  changeRequest?: IChangeRequest
): ICurrentChanges | undefined => {
  const originalAlbum = changeRequest?.originalAlbum;
  const changeRequestAlbum = changeRequest?.changeRequestAlbum;

  if (!originalAlbum || !changeRequestAlbum) {
    return undefined;
  }

  const hasMerchandiseMetadata =
    !!originalAlbum.merchandiseMetadata ||
    !!changeRequestAlbum.merchandiseMetadata;

  return hasMerchandiseMetadata
    ? merchCurrentChanges(originalAlbum, changeRequestAlbum)
    : productCurrentChanges(originalAlbum, changeRequestAlbum);
};
